import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  RemainingCreditRequest,
  RemainingCreditsQuery,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../../utils";

const remainingCreditsQuery = graphql(`
  query remainingCredits($request: RemainingCreditRequest!) {
    remainingCredits(RemainingCreditRequest: $request) {
      remainingCredits
    }
  }
`);

export function useRemainingCredits(
  remainingCreditsRequest: RemainingCreditRequest,
  options?: UseQueryOptions<RemainingCreditsQuery, unknown, RemainingCreditsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["remainingCredits", remainingCreditsRequest.creditType],
    remainingCreditsQuery,
    [{ request: remainingCreditsRequest }],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );

  return { data: data?.remainingCredits, ...rest };
}
